// extracted by mini-css-extract-plugin
module.exports = {"root":"DspxPagination_root__2JnlN","quickJumperToStart":"DspxPagination_quickJumperToStart__2Sdxg"};